import styled from 'styled-components'

export const Wrapper = styled.div`
  min-height: 320px;
  padding-top: 4px;
  overflow: visible;

  /* Anula márgenes negativos globales del Modal (.ant-modal-body .ant-row) */
  .rankmiTable-container .ant-row {
    margin-top: 0 !important;
    margin-bottom: 16px !important;
    align-items: center;
  }

  .rankmiTable-container .ant-row .mb-2 {
    margin-bottom: 0 !important;
  }

  .rankmiTable-container .rankmiTable-rowsCount {
    align-items: center;
    margin-bottom: 0;
  }
`

export const RankmiTableWrapper = styled.div`
  width: 100%;
  overflow: visible;

  .rankmiTable-container {
    overflow: visible;
  }

  .ant-table-wrapper {
    margin-top: 0;
  }

  .rankmiTable-searchInput {
    width: 280px;
    max-width: 100%;
  }

  .rankmiTable-pagination,
  .rankmiTable-container .rankmiTable-pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
`
